import { useEffect, useState } from "react";
import { profitBranchSummary } from "@/lib/api";
import { formatINR, todayISO } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Kpi, Th, Td, MONEY_COLS, MoneyCells, ProfitCell } from "./ProfitUI";

const monthStart = () => todayISO().slice(0, 8) + "01";

export function BranchReportTab() {
  const [range, setRange] = useState({ start_date: monthStart(), end_date: todayISO() });
  const [data, setData] = useState(null);

  useEffect(() => {
    if (range.start_date && range.end_date) profitBranchSummary(range).then(setData);
  }, [range]);

  const c = data?.combined || {};

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center gap-3">
        {["start_date", "end_date"].map((k) => (
          <div key={k} className="flex items-center gap-2">
            <Label className="text-xs uppercase tracking-widest text-zinc-500">{k === "start_date" ? "From" : "To"}</Label>
            <Input type="date" className="w-40" value={range[k]} onChange={(e) => setRange((r) => ({ ...r, [k]: e.target.value }))} data-testid={`branch-report-${k.replace("_", "-")}-input`} />
          </div>
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 tabular">
        <Kpi label="Combined Commission" value={c.total_commission} testId="branch-kpi-commission" />
        <Kpi label="Combined DC Loss" value={c.dc_loss} tone="warning" testId="branch-kpi-dc-loss" />
        <Kpi label="Combined Min Guarantee" value={c.min_guarantee} tone="warning" testId="branch-kpi-mg" />
        <Kpi label="Combined Final Profit" value={c.final_profit} tone={c.final_profit >= 0 ? "positive" : "danger"} big testId="branch-kpi-profit" />
      </div>
      <div className="bg-white rounded-xl border border-zinc-200 overflow-x-auto">
        <table className="w-full text-sm" data-testid="branch-report-table">
          <thead className="bg-zinc-50 border-b border-zinc-200">
            <tr className="text-left">
              <Th>Branch</Th><Th className="text-right">Days</Th>
              {MONEY_COLS.map(([k, l]) => <Th key={k} className="text-right">{l}</Th>)}
              <Th className="text-right">Final Profit</Th>
            </tr>
          </thead>
          <tbody>
            {(data?.branches || []).map((b) => (
              <tr key={b.branch_id} className="border-b border-zinc-100 tabular" data-testid={`branch-row-${b.branch_name}`}>
                <td className="px-3 py-2.5 font-medium whitespace-nowrap">{b.branch_name}</td>
                <Td className="text-zinc-500">{b.days_with_data}</Td>
                <MoneyCells row={b} />
                <ProfitCell value={b.final_profit} testId={`branch-profit-${b.branch_name}`} />
              </tr>
            ))}
            {data && (
              <tr className="bg-emerald-50/60 font-semibold tabular" data-testid="branch-row-combined">
                <td className="px-3 py-2.5">All branches</td>
                <Td>{c.days_with_data}</Td>
                {MONEY_COLS.map(([k]) => <Td key={k}>{formatINR(c[k])}</Td>)}
                <ProfitCell value={c.final_profit} testId="branch-profit-combined" />
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
